module.exports = __webpack_public_path__ + "img/Save@2x.71ccd138.png";